export default __webpack_public_path__ + "static/media/checkmark.8e82e382.svg";